var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseText',{staticClass:"wrn-link terms-link",attrs:{"as":"a","size":"sm","target":"_blank","rel":"noopener","href":_vm.termsLink}},[_vm._v(" "+_vm._s(_vm.termsText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }